import ChoiceDeleteOverlay from './ChoiceDeleteOverlay';

export default ChoiceDeleteOverlay;
